import React from 'react';
import { motion } from 'framer-motion';

function RoutePath({ className = '', reverse = false }) {
  const path = reverse
    ? 'M360 24C266 10 228 102 148 84C82 69 60 118 14 126'
    : 'M12 116C84 116 80 25 170 42C249 58 271 6 362 20';

  return (
    <svg
      className={`route-path ${className}`}
      viewBox="0 0 375 140"
      aria-hidden="true"
      focusable="false"
    >
      <motion.path
        d={path}
        fill="none"
        initial={{ pathLength: 0, opacity: 0 }}
        whileInView={{ pathLength: 1, opacity: 1 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 1.4, ease: 'easeOut' }}
      />
    </svg>
  );
}

export default RoutePath;